import MuiModal from '@mui/material/Modal';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import React from 'react';
import { ButtonFlatMedium, ButtonPrimaryMedium } from '../Buttons';
import { BodyLargeEmphasized } from '../Typography';
import styles from './Modal.styles';
import { AccessibleDivButton } from '@/components';

interface Props {
  title: string;
  isOpen: boolean;
  children?: React.ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
  disableCancelButton?: boolean;
  disableConfirmButton?: boolean;
}

export const Modal: React.FC<Props> = ({
  title,
  children,
  isOpen,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  onConfirm,
  onCancel,
  onClose,
  disableCancelButton = false,
  disableConfirmButton = false,
}) => {
  return (
    <MuiModal
      open={isOpen}
      onClose={onClose}
    >
      <div className={styles.container}>
        <div className={styles.modalTitleContainer}>
          <AccessibleDivButton className={styles.closeButton} onClick={onClose}>
            <CloseOutlinedIcon  />
          </AccessibleDivButton>
          <BodyLargeEmphasized className={styles.title}>
            {title}
          </BodyLargeEmphasized>
        </div>
        <div className={styles.content}>
          {children}
        </div>
        <div className={styles.footer}>
          <ButtonFlatMedium
            onClick={onCancel}
            disabled={disableCancelButton}
          >
             {cancelButtonText}
          </ButtonFlatMedium>
          <ButtonPrimaryMedium
            autoFocus
            onClick={onConfirm}
            disabled={disableConfirmButton}
          >
            {confirmButtonText}
          </ButtonPrimaryMedium>
        </div>
      </div>
    </MuiModal>
  );
};
